//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// TODO: 暂时没有考虑bridge没有加载成功的场景
import { invokeShareByManual, env, share } from '@changba/funny';
import { props } from './props';
import { defineComponent } from '../utils/create';
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    ref: "top",
    staticClass: "cb-top-bar",
    class: {
      'is-android': _vm.isAndroid
    }
  }, [_c('span', {
    staticClass: "cb-top-bar__back",
    class: {
      'is-light': _vm.theme === 'light',
      'is-dark': _vm.theme === 'dark',
      'is-circle': _vm.circle
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleBack.apply(null, arguments);
      }
    }
  }), _vm._v(" "), !_vm.disabledShare ? _c('span', {
    staticClass: "cb-top-bar__share",
    class: {
      'is-light': _vm.theme === 'light',
      'is-dark': _vm.theme === 'dark',
      'is-circle': _vm.circle
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.handleShare.apply(null, arguments);
      }
    }
  }) : _vm._e()]);
};
var staticRenderFns = [];
export default defineComponent({
  _scopeId: 'data-v-3cc1d50a',
  render,
  name: 'CbTopBar',
  props,
  computed: {
    visible() {
      return process.env.NODE_ENV !== 'production' || this.isNewWebview && env.browser.isChangba;
    },
    isNewWebview() {
      return env.webviewType === 'new';
    },
    isAndroid() {
      return env.browser.isAndroid;
    }
  },
  mounted() {
    this.setDefaultShare();
  },
  methods: {
    setDefaultShare() {
      if (!this.isNewWebview && !this.disabledShare) {
        share(this.shareParams);
      }
    },
    handleBack() {
      this.onBack();
    },
    handleShare() {
      invokeShareByManual(this.shareParams);
    }
  }
});